<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-multiselect.selector.examples-type-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :hide-selected='false',
            :allow-empty="false",
            :max="2",
            label="label",
            :value="selectedExamplesType",
            :options="examplesTypes",
            :disabled="gameState === 'started'",
            @select="setSelectedExampleType($event)",
        )
        cs-multiselect.selector.divisible-multiplier-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            label="value",
            :close-on-select="true",
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')",
            :allow-empty="false",
            v-model="selectedDivisibleMultiplierValue",
            :options="divisibleMultiplierOptions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                |
        cs-multiselect.selector.divider-multiplier-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            label="value",
            :close-on-select="true",
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')",
            :allow-empty="false",
            v-model="selectedDividerMultiplierValue",
            :options="dividerMultiplierOptions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}:
                |
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
</template>

<script>
/*eslint-disable*/

    import MultiplayerOptionsMixin from '../../../utils/multiplayer/optionsMixin';
    import { cloneDeep, mapValues } from 'lodash';

    const MULTIPLY_ACTION = 'multiply';
    const DIVIDE_ACTION = 'divide';
    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';

    export default {
        mounted() {
            this.selectedExamplesType = this.examplesTypes.find(type => {
                if (this.commonParams.operations.multiply) {
                    return type.action === MULTIPLY_ACTION;
                } else if (this.commonParams.operations.divide) {
                    return type.action === DIVIDE_ACTION;
                }
                return false;
            });
            this.selectedDivisibleMultiplierValue = this.divisibleMultiplierOptions.find(option => {
                return this.commonParams.digitCapacity.left.includes(option.value);
            });
            this.selectedDividerMultiplierValue = this.dividerMultiplierOptions.find(option => {
                return this.commonParams.digitCapacity.right.includes(option.value);
            });
            //set first multiselect tags to be in one height with another
            let examplesTypeMultiselectTags = document.querySelector('.multiselect__tags');
            if (examplesTypeMultiselectTags) {
                examplesTypeMultiselectTags.style.cssText = 'padding: 8px 15px';
            }
            if (this.paramsArray.some(params => params.extraOperations.abCrossAc)) {
                this.commonParams.extraOperations.abCrossAc = true;
            }
            if (this.paramsArray.some(params => params.extraOperations.rule101.isChosen)) {
                this.commonParams.extraOperations.rule101.isChosen = true;
            }
            if (this.paramsArray.some(params => params.extraOperations.mirror.isChosen)) {
                this.commonParams.extraOperations.mirror.isChosen = true;
            }
        },
        mixins: [MultiplayerOptionsMixin],
        watch: {
            'commonParams.extraOperations.rule101.isChosen': {
                handler(val) {
                    val && (this.selectedDividerMultiplierValue = this.difficultyOptions[0]);
                },
            },
            selectedExamplesType: {
                handler(value, oldValue) {
                    if (value) {
                        if (value.action !== MULTIPLY_ACTION) {
                            this.commonParams.operations[MULTIPLY_ACTION] = false;
                            this.commonParams.operations[DIVIDE_ACTION] = true;
                            this.handleExtraOperationsToggling(value, oldValue);
                        }
                        if (value.action !== DIVIDE_ACTION) {
                            this.commonParams.operations[DIVIDE_ACTION] = false;
                            this.commonParams.operations[MULTIPLY_ACTION] = true;
                        }
                        this.commonParams.operations.action = value.action;
                        if (oldValue !== null) {
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                setOperationsValues: true,
                                names: [MULTIPLY_ACTION, DIVIDE_ACTION],
                                values: [
                                    this.commonParams.operations[MULTIPLY_ACTION],
                                    this.commonParams.operations[DIVIDE_ACTION],
                                ],
                            });
                        }
                    }
                },
                immediate: true,
            },
            selectedDivisibleMultiplierValue: {
                handler(value, oldValue) {
                    this.handleExtraOperationsToggling(value, oldValue);
                    if (value) {
                        this.commonParams.digitCapacity.left = [value.value];
                        if (oldValue !== null) {
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                name: 'left',
                                value: this.commonParams.digitCapacity.left,
                            });
                            if (this.commonParams.digitCapacity.left[0] < this.commonParams.digitCapacity.right[0]) {
                                this.selectedDividerMultiplierValue = this.dividerMultiplierOptions.find(
                                    option => option.value === this.commonParams.digitCapacity.left[0]
                                );
                            }
                        }
                    }
                },
                immediate: true,
            },
            selectedDividerMultiplierValue: {
                handler(value, oldValue) {
                    this.handleExtraOperationsToggling(value, oldValue);
                    if (value) {
                        this.commonParams.digitCapacity.right = [value.value];
                        if (oldValue !== null) {
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                name: 'right',
                                value: this.commonParams.digitCapacity.right,
                            });
                        }
                    }
                },
                immediate: true,
            },
        },
        data() {
            return {
                selectedExamplesType: null,
                examplesTypes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_multiplication'),
                        action: MULTIPLY_ACTION,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_division'),
                        action: DIVIDE_ACTION,
                    },
                ],
                selectedDivisibleMultiplierValue: null,
                selectedDividerMultiplierValue: null,
                difficultyOptions: [
                    {
                        value: 1,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                        $isDisabled: false,
                    },
                    {
                        value: 2,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                        $isDisabled: false,
                    },
                    {
                        value: 3,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                        $isDisabled: false,
                    },
                    {
                        value: 4,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                        $isDisabled: false,
                    },
                    {
                        value: 5,
                        label: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                        $isDisabled: false,
                    },
                ],
            };
        },
        methods: {
            handleExtraOperationsToggling(value, oldValue) {
                if (
                    value !== null &&
                    oldValue !== undefined &&
                    this.paramsArray.some(params => params.extraOperations.rule101.isChosen)
                ) {
                    this.commonParams.extraOperations.rule101 = mapValues(
                        this.commonParams.extraOperations.rule101,
                        () => false
                    );
                    this.commonParams.extraOperations.rule101.isChosen = false;
                    this.selectedDividerMultiplierValue = this.difficultyOptions[0];
                }
            },
            setSelectedExampleType(type) {
                this.selectedExamplesType = type;
            },
        },
        computed: {
            dividerMultiplierOptions() {
                let options = cloneDeep(this.difficultyOptions);
                options.forEach(option => {
                    option.$isDisabled =
                        !this.selectedDivisibleMultiplierValue ||
                        this.selectedDivisibleMultiplierValue.value < option.value;
                });
                if (this.selectedExamplesType?.action === DIVIDE_ACTION) {
                    this.selectedDividerMultiplierValue = this.difficultyOptions[0];
                    return options.slice(0, 1);
                }
                return options;
            },
            divisibleMultiplierOptions() {
                let options = cloneDeep(this.difficultyOptions);
                if (this.selectedExamplesType?.action === DIVIDE_ACTION) {
                    this.selectedDivisibleMultiplierValue = this.difficultyOptions[2];
                    return options.slice(2, 4);
                }
                return options;
            },
        },
    };
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1439px) {
            max-width: 175px;
        }
    }
</style>
